﻿$.fn.dxCtrlGridTemplateDisplay = function custom_dxCtrlGridTemplateDisplay(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-dxctrlgridtemplatedisplay dx-ctrl");
        this.createInstance(new cdxCtrlGridTemplateDisplay(this, option));
    }
    return this;
}

window.cdxCtrlGridTemplateDisplay = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
        }
    }

    var jauge = null
    function mConstruit() {
        container.empty();
        if (option.dataTemplate) {
            container.attr("id_table", option.dataTemplate.id_table_key)
            container.attr("id", option.dataTemplate.id_key)
        }

        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        var jsonGrid = ""
        if (typeof option.dataGridVue != 'undefined' && option.dataGridVue != null) {
            if ((typeof option.onChange != 'undefined' && option.onChange != null) || (typeof option.onChanged != 'undefined' && option.onChanged != null)) {
                if (option.typeDisplay == "formulaire") {
                    jsonGrid = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataForm(option.dataGridVue.id_grid_vue, option.bddCtrl.table.mGetItem(option.dataTemplate.id_table_key).nom).json
                } else {
                    jsonGrid = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataModif(option.dataGridVue.id_grid_vue, option.bddCtrl.table.mGetItem(option.dataTemplate.id_table_key).nom).json
                }
            } else {
                jsonGrid = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataVisu(option.dataGridVue.id_grid_vue, option.bddCtrl.table.mGetItem(option.dataTemplate.id_table_key).nom).json
            }
        }
        if (jsonGrid.length == 0) {
            if ((typeof option.onChange != 'undefined' && option.onChange != null) || (typeof option.onChanged != 'undefined' && option.onChanged != null)) {
                jsonGrid = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataModif(null, option.table.nom).json
            } else {
                jsonGrid = option.bddCtrl.getObjet("template_form").objetMetier.mGetDataVisu(null, option.table.nom).json
            }
        }
        var grid = JSON.parse(jsonGrid).sort(function (o1, o2) { return o1.y - o2.y || o1.x - o2.x })
        var lstIdChampTableDisplayed = []

        if (parametre.isPhone) {
            grid.forEach(function (configGrid) {
                var field = option.fields.filter(function (o) { return o.dataField == configGrid.dataField })[0]
                if (typeof field != 'undefined') {
                    try {
                        if (typeof option.lstIdChampTableHided == 'undefined' || typeof field.dataChampTable == 'undefined' ||
                            (typeof option.lstIdChampTableHided != 'undefined' &&
                                !option.lstIdChampTableHided.contains(field.dataChampTable.id_champ_table))) {
                            if (typeof field.dataChampTable != 'undefined') lstIdChampTableDisplayed.push(field.dataChampTable.id_champ_table)
                            var h = 0 // 30 * configGrid.h
                            var $DivField = $("<div style='min-height:" + h + "px;width:100%;display:flex;align-items:center;'/>").appendTo(container)
                            var dxField = $("<div style='width:100%;'/>").appendTo($DivField).dxCtrlField({
                                bddCtrl: option.bddCtrl,
                                dataTemplate: option.dataTemplate,
                                onChange: option.onChange,
                                onChanged: option.onChanged,
                                field: field,
                                typeDisplay: option.typeDisplay,
                                onDemandeDisplaysite: option.onDemandeDisplaysite,
                                //onDemandeAnalysesiteIa: option.onDemandeAnalysesiteIa,
                                configGrid: configGrid,
                                onDemandeSaveObjets: function (objets, funcSavePhoto) {
                                    jauge.mShow()
                                    if (typeof funcSavePhoto != 'undefined' && funcSavePhoto != null) {
                                        funcSavePhoto(function () { mSaveReste() })
                                    } else {
                                        mSaveReste()
                                    }
                                    function mSaveReste() {
                                        objets.mSave(function (data) {
                                            if (typeof option.onModifAllObjet != 'undefined') { jauge.mHide(); option.onModifAllObjet() }
                                            else {
                                                option.bddCtrl.mAjaxCall({
                                                    command: "getlstdatavirtualgrid",
                                                    data: [{ id_table: option.dataTemplate.id_table, id: option.dataTemplate.id }],
                                                    lst_id_champ_table: "all"
                                                }, function (data) {
                                                    option.dataTemplate = data.lstdatatemplate[0]
                                                    mConstruit()
                                                })
                                            }
                                        }, null, null, true, { disableTriggerModif: true })
                                    }
                                },
                                isForDoublon: option.isForDoublon,
                                onDemandeReload: function () {
                                    mConstruit()
                                }
                            }).dxCtrlField("instance")
                            if (dxFirstField == null) dxFirstField = dxField
                        }

                    } catch (e) {
                        debugger
                        mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                    }
                }
            })
        } else {
            //if (option.dataTemplate.id_import_auto) {
            //    var nomFiche = option.bddCtrl.getObjet("import_auto", option.dataTemplate.id_import_auto).data.nom_fiche
            //    var $DivImportAuto = $("<div/>").appendTo(container)
            //    var $A = $("<a href='javascript:void(0)'><span>➲</span>Cette fiche est issue d'une fiche <b>" + nomFiche + "</b></a>").appendTo($DivImportAuto)
            //    $A.on("click", function (e) {
            //        var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
            //            target: $A,
            //            contentTemplate: function (contentElement) {
            //                contentElement.css("padding", "30px")
            //                $("<div>Cette fiche est lié à une fiche " + nomFiche + "</div>").appendTo(contentElement)
            //                $("<div>Vous pouvez désactiver la fiche " + nomFiche + "<br/>pour couper le lien de mise à jour<br/>entre " + nomFiche + " et " + parametre.nom + ".</div>").appendTo(contentElement)
            //                $("<div style='margin-top:20px'/>").appendTo(contentElement).dxCtrlButton({
            //                    text: "Désactiver",
            //                    onClick: function (e) {
            //                        tt.hide()
            //                        jaugeDemarrage.mShow()
            //                        option.bddCtrl.mAjaxCall({
            //                            command: "importautodetachefiche",
            //                            lst_id_table_id: { id_table: option.dataTemplate.id_table_key, id: option.dataTemplate.id_key },
            //                            id_import_auto: option.dataTemplate.id_import_auto
            //                        }, function (data) {
            //                            jaugeDemarrage.mHide()
            //                            if (option.onChanged) option.onChanged()
            //                        })
            //                    }
            //                })
            //            }
            //        }).dxCtrlTooltip("instance")
            //        tt.show()
            //    })
            //}

            var $DivChampsRempliManquant = $("<div/>").appendTo(container)

            var maxh = 0
            grid.forEach(function (data) {
                if (maxh < data.y + 1 + (data.h - 1)) maxh = data.y + 1 + (data.h - 1)
            })
            var matrice = []
            for (lig = 1; lig <= maxh; lig++) {
                matrice.push([])
                for (col = 1; col <= 20; col++) {
                    matrice[matrice.length - 1].push(false)
                }
            }
            grid.forEach(function (item) {
                for (lig = item.y; lig < item.h + (item.y); lig++) {
                    for (col = item.x; col < item.w + (item.x); col++) {
                        matrice[lig][col] = true
                    }
                }
            })
            matrice.forEach(function (ligne, idxLig) {
                ligne.forEach(function (colonne, idxCol) {
                    if (!colonne) {
                        grid.push({
                            x: idxCol,
                            y: idxLig,
                            w: 1,
                            h: 1
                        })
                    }
                })
            })
            grid = grid.sort(function (o1, o2) { return o1.y - o2.y || o1.x - o2.x })

            var $Table = $("<table style='width:100%;table-layout:fixed;'/>").appendTo(container)
            var $Tr = $("<tr class='trte'/>").appendTo($Table)
            var $Td = $("<td style='width:0px'></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)
            var $Td = $("<td style=''></td>").appendTo($Tr)

            var tabTr = []
            for (i = 1; i <= maxh; i++) {
                var $Tr = $("<tr class='trte tr_fake_height'/>").appendTo($Table)
                var $Td = $("<td style='width:0px'></td>").appendTo($Tr)
                tabTr.push($Tr)
            }
            var yEnCour = null
            var dxFirstField = null
            grid.forEach(function (configGrid) {
                $Tr = tabTr[configGrid.y]
                //if (yEnCour != configGrid.y) {
                //    yEnCour = configGrid.y
                //    $Tr = $("<tr class='trte' style='height:22px;'/>").appendTo($Table)
                //    var $Td = $("<td style=''></td>").appendTo($Tr)
                //}
                var field = option.fields.filter(function (o) { return o.dataField == configGrid.dataField })[0]
                var $Td = $("<td style=''></td>").appendTo($Tr)
                var containerField = $Td
                if (configGrid.h == 1) {
                    $Td.css({
                        "overflow": "hidden",
                        "text-overflow": "ellipsis",
                        "white-space": "nowrap"
                    })
                } else {
                    if (typeof field != 'undefined' && !field.gridTemplate.notEllipsis) {
                        containerField = $("<div class='ellipsismultiligne" + configGrid.h + "'/>").appendTo($Td)
                        //$Td.addClass("ellipsismultiligne" + configGrid.h)
                    } else {
                        $Td.css({
                            "overflow": "hidden",
                            "text-overflow": "ellipsis",
                            "white-space": "nowrap"
                        })
                    }
                }
                if (typeof field != 'undefined' && field.gridTemplate.fixed) {
                    $Td.css("width", (30 * configGrid.w) + "px")
                } else {
                    $Td.css("width", (5 * configGrid.w) + "%")
                }
                $Td.addClass("td_fake_height")
                $Td.addClass("tdgridtemplate")
                $Td.attr("colspan", configGrid.w)
                $Td.attr("rowspan", configGrid.h)

                if (typeof option.paddingTd != 'undefined' && option.paddingTd != null) $Td.css("padding", option.paddingTd + "px")
                if (typeof field != 'undefined') {
                    try {
                        if (typeof option.lstIdChampTableHided == 'undefined' || typeof field.dataChampTable == 'undefined' ||
                            (typeof option.lstIdChampTableHided != 'undefined' &&
                                !option.lstIdChampTableHided.contains(field.dataChampTable.id_champ_table))) {
                            if (typeof field.dataChampTable != 'undefined') lstIdChampTableDisplayed.push(field.dataChampTable.id_champ_table)
                            var dxField = $("<div style='width:100%;'/>").appendTo(containerField).dxCtrlField({
                                bddCtrl: option.bddCtrl,
                                dataTemplate: option.dataTemplate,
                                onChange: option.onChange,
                                onChanged: option.onChanged,
                                field: field,
                                typeDisplay: option.typeDisplay,
                                onDemandeDisplaysite: option.onDemandeDisplaysite,
                                //onDemandeAnalysesiteIa: option.onDemandeAnalysesiteIa,
                                configGrid: configGrid,
                                onDemandeSaveObjets: function (objets, funcSavePhoto) {
                                    jauge.mShow()
                                    if (typeof funcSavePhoto != 'undefined' && funcSavePhoto != null) {
                                        funcSavePhoto(function () { mSaveReste() })
                                    } else {
                                        mSaveReste()
                                    }
                                    function mSaveReste() {
                                        objets.mSave(function (data) {
                                            if (typeof option.onModifAllObjet != 'undefined') { jauge.mHide(); option.onModifAllObjet() }
                                            else {
                                                option.bddCtrl.mAjaxCall({
                                                    command: "getlstdatavirtualgrid",
                                                    data: [{ id_table: option.dataTemplate.id_table, id: option.dataTemplate.id }],
                                                    lst_id_champ_table: "all"
                                                }, function (data) {
                                                    option.dataTemplate = data.lstdatatemplate[0]
                                                    mConstruit()
                                                })
                                            }
                                        }, null, null, true, { disableTriggerModif: true })
                                    }
                                },
                                isForDoublon: option.isForDoublon,
                                onDemandeReload: function () {
                                    mConstruit()
                                }
                            }).dxCtrlField("instance")
                            if (dxFirstField == null) dxFirstField = dxField
                        }

                    } catch (e) {
                        debugger
                        mTraiteMessageJs("erreurjs", e.message, $(location).attr("href"), 0, null, e, "orange")
                    }
                }
            })

            if (option.typeDisplay == "formulaire") {
                var lstIdChampTableWithValue = Object.keys(option.dataTemplate)
                    .filter(key => key.match(/^cpcht(\d+)\.id$/) && option.dataTemplate[key] !== null)
                    .map(key => key.match(/^cpcht(\d+)\.id$/)[1]);
                if (typeof option.lstIdChampTableHided != 'undefined') lstIdChampTableWithValue = lstIdChampTableWithValue.concat(option.lstIdChampTableHided)
                var lstIdChampTableRempliNotDisplayed = lstIdChampTableWithValue.filter(function (idChpTab) {
                    if (!lstIdChampTableDisplayed.contains(idChpTab)) {
                        if (idChpTab == parametre.champ.id_champ_table_nomstructure && option.bddCtrl.table.mGetItem(option.dataTemplate.id_table_key).nom == "structures_contact") {
                            return false
                        } else if (idChpTab == parametre.champ.id_champ_table_nomprenom && option.bddCtrl.table.mGetItem(option.dataTemplate.id_table_key).nom == "contact") {
                            return false
                        } else { return true }
                    } else { return false }
                })
                if (lstIdChampTableRempliNotDisplayed.length > 0) {
                    var lstDataChpTab = option.bddCtrl.mGetArray("champ_table").filter(function (dataChp) { return lstIdChampTableRempliNotDisplayed.contains(dataChp.id_champ_table) })
                    var txt = ""
                    lstDataChpTab.forEach(function (dataChampTable) {
                        txt += ((txt.length > 0) ? ", " : "") + dataChampTable.nom
                    })
                    var $DivAdd = null
                    if (lstDataChpTab.length == 1) {
                        $DivAdd = $("<div style='color:orange;font-family:Barlow Condensed;'><u>Le champ <b>" + txt + "</b> est rempli mais pas affiché.</u></div>").appendTo($DivChampsRempliManquant)
                    } else {
                        $DivAdd = $("<div style='color:orange;font-family:Barlow Condensed;'><u>Les champs <b>" + txt + "</b> sont remplis mais pas affichés.</u></div>").appendTo($DivChampsRempliManquant)
                    }
                    if (typeof option.onDemandeChangeDisplay != 'undefined' && option.onDemandeChangeDisplay != null) {
                        $DivAdd.addClass("state-hover")
                        $DivAdd.on("click", function () {
                            option.onDemandeChangeDisplay()
                        })
                    } else { $DivChampsRempliManquant.hide() }
                }
            }

        }

        if (dxFirstField != null) {
            window.setTimeout(function () { dxFirstField.focus() }, 100)
        }
    }

    this.element = function () { return container }
    this.component = function () { return dx }

    mConstruit();
}